import React, { useState } from "react";
import { SetupDataPageTemplate } from "../../../components/setup-pages/SetupDataPageTemplate";
import { setupData } from "../../../configs/routes";
import * as userService from "../../../services/userService";
import { pathRoot } from "../Consent";
import { HelpPopup } from "../../../components/HelpPopup";
import { HelpButtonExpanded } from "../../../components/common/HelpButtonExpanded";

export function Page1() {
	const [isShowingConsentHelp, setIsShowingConsentHelp] = useState(false);
	const [helpCode, setHelpCode] = useState();

	const handleShowHelp = (helpCode) => {
		setHelpCode(helpCode);
		setIsShowingConsentHelp(true);
	};

	const headerDetails = {
		title: "Consent",
		currentPage: 1,
		pageCount: 2,
	};

	return (
		<SetupDataPageTemplate
			headerDetails={headerDetails}
			backTo={setupData}
			nextTo={`${pathRoot}/2`}
			onClickBack={userService.resetUserSettings}
		>
			<p className={"my-3 sm:mb-6 leading-tight lg:leading-6 font-bold"}>
				Here is where you consent to us to use and share (anonymously) your
				data.
			</p>
			<p
				className={
					"mb-4 sm:mb-6 text-sm lg:text-base leading-tight lg:leading-6"
				}
			>
				We have supplied this companion for you to help you support yourself and
				to keep a diary of your symptoms and quality of life. You will already
				have read and signed consent during registration. Here is the user
				information and terms and conditions of use for you to read again if you
				wish.
			</p>

			<div className={"w-full mx-auto space-y-2 mb-4 sm:mb-6"}>
				<HelpButtonExpanded
					onClick={() => handleShowHelp("Home.setup.consentINFO")}
					text={"Health Companion User Info"}
					linkColorOverride="text-app-midblue"
					textSizeOverride="text-md"
				/>
				<HelpButtonExpanded
					onClick={() => handleShowHelp("Home.setup.TandCs")}
					text={"Terms and Conditions of use"}
					linkColorOverride="text-app-midblue"
					textSizeOverride="text-md"
				/>
			</div>

			{/* <p className={"leading-tight lg:leading-6"}>
			The User Information explains the following:
			</p>
			<ol
				className={"list-decimal list-outside ml-4 my-4 text-sm leading-tight"}
			>
				<li className={"pb-2"}>What is the Health Companion?</li>
				<li className={"pb-2"}>What are cancer registries and why is this information needed?</li>
				<li className={"pb-2"}>Who can use the Health Companion & what are the benefits?</li>
				<li className={"pb-2"}>What data does the Health Companion collect?</li>
				<li className={"pb-2"}>
					How often and for how long will I need to use the Health Companion?
				</li>
				<li className={"pb-2"}>Who has access to the data and how they will use it?</li>
				<li className={"pb-2"}>How we keep data safe?</li>
				<li className={"pb-2"}>Who developed the Health Companion?</li>
				<li className={"pb-2"}>Who manages the Health Companion?</li>
				<li className={"pb-2"}>How has the Health Companion been funded?</li>
				<li className={"pb-2"}>Who can I contact with any questions, concerns or complaints?</li>
				<li>Can I withdraw my consent?</li>
			</ol> */}

			<p className={"my-4 sm:mb-6 leading-tight font-bold"}>
				You can change your consent at any time by coming back here.
			</p>

			<HelpPopup
				show={isShowingConsentHelp}
				onClose={() => setIsShowingConsentHelp(false)}
				helpCode={helpCode}
			/>
		</SetupDataPageTemplate>
	);
}
